module.exports = __webpack_public_path__ + "3c65f06b6a3896db5a8cb2689f1a70c7.png";